export default __webpack_public_path__ + "static/media/wave.4b63bbaa.svg";